import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=6f9c62c8&scoped=true"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"
import style0 from "./Facturas.vue?vue&type=style&index=0&id=6f9c62c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c62c8",
  null
  
)

export default component.exports